import { render, staticRenderFns } from "./QuickAccessBar.vue?vue&type=template&id=481e1094&scoped=true&"
import script from "./QuickAccessBar.vue?vue&type=script&lang=js&"
export * from "./QuickAccessBar.vue?vue&type=script&lang=js&"
import style0 from "./QuickAccessBar.vue?vue&type=style&index=0&id=481e1094&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481e1094",
  null
  
)

export default component.exports